import { useEffect, useState } from "react";
import axios from "axios";
import { PUBLIC_TOOLS_API } from "./publicAudioTools";

export function useAudioExportSettings(preference = "audio") {
  const [catalog, setCatalog] = useState(null);
  const [error, setError] = useState("");
  const [format, setFormat] = useState(() => {
    try { return localStorage.getItem(`steelmora-export-${preference}`) || "mp3"; } catch { return "mp3"; }
  });
  const [qualities, setQualities] = useState({});
  useEffect(() => {
    const controller = new AbortController();
    axios.get(`${PUBLIC_TOOLS_API}/formats`, { signal: controller.signal }).then(({ data }) => {
      if (!Array.isArray(data.formats)) throw new Error("Catalogo de formatos no disponible");
      setCatalog(data);
    }).catch(() => { if (!controller.signal.aborted) setError("No se pudieron consultar los codificadores del servidor. Recarga para reintentar."); });
    return () => controller.abort();
  }, []);
  useEffect(() => {
    if (!catalog) return;
    if (!catalog.formats.some(item => item.id === format && item.can_encode)) {
      setFormat(catalog.formats.find(item => item.can_encode)?.id || "");
    }
  }, [catalog, format]);
  const selected = catalog?.formats.find(item => item.id === format);
  const quality = qualities[format] || {};
  const changeFormat = (value) => {
    setFormat(value);
    try { localStorage.setItem(`steelmora-export-${preference}`, value); } catch { /* Storage can be disabled. */ }
  };
  const changeQuality = (key, value) => setQualities(current => {
    const next = { ...(current[format] || {}) };
    if (value === "source") delete next[key]; else next[key] = Number(value);
    return { ...current, [format]: next };
  });
  return { catalog, error, format, setFormat: changeFormat, selected, quality, changeQuality,
    ready: Boolean(selected?.can_encode), inputAccept: catalog?.input_extensions.map(ext => `.${ext}`).join(",") || "" };
}

export function outputInfo(selected, quality, source = {}) {
  if (!selected) return null;
  const original = source.sample_rate || 48000;
  let rate = !selected.sample_rates.length || selected.sample_rates.includes(original) ? original
    : selected.sample_rates.reduce((a, b) => Math.abs(a - original) < Math.abs(b - original) ? a : b);
  const channels = source.channels || 2;
  const defaults = Object.fromEntries(Object.entries(selected.quality_options).map(([key, config]) => [key, config.default]));
  const values = { ...defaults, ...quality };
  if (selected.id === "mp3" && rate < 32000 && values.bitrate_kbps > 160) rate = 32000;
  const bits = values.bit_depth === "source" ? (source.bits_per_sample > 16 ? 24 : 16) : values.bit_depth || 32;
  const bytes = source.duration_seconds && selected.id !== "wma" ? source.duration_seconds * (values.bitrate_kbps ? values.bitrate_kbps * 125 : rate * channels * bits / 8) : null;
  return { rate: source.sample_rate ? rate : selected.sample_rates.length === 1 ? selected.sample_rates[0] : null,
    channels: source.channels || null, bytes, approximate: !["wav", "aiff"].includes(selected.id), upperBound: ["flac", "alac", "ogg"].includes(selected.id),
    compatible: channels <= selected.max_channels };
}
